import React from 'react';

import { Box, Alert, AlertDescription } from '@vimeo/bokeh';
import { SlideUpDown } from '@vimeo/live-core/components/slide_up_down';

import { createInteractionDomName } from '../../../../libs/shared/utils/dom/identifying';
import { INoticeProps } from './useNoticeProps';

export function ChatHistoryNotice({ content, showing, onClickAction }: INoticeProps) {
  return (
    <Box
      className={createInteractionDomName('chat-notice-slider-wrapper')}
      position={'absolute'}
      opacity={showing ? 1 : 0}
    >
      <SlideUpDown showing={showing}>
        <Box
          className={createInteractionDomName('chat-notice-wrapper')}
          cursor={'pointer'}
          backgroundColor={'surface'}
          onClick={onClickAction}
        >
          <Alert status={'info'}>
            <AlertDescription className={createInteractionDomName('chat-notice-text')}>
              {content}
            </AlertDescription>
          </Alert>
        </Box>
      </SlideUpDown>
    </Box>
  );
}
